<div class="row">
  @for (owner of ownerFormArray?.controls; track owner; let index = $index) {
    @if (owner) {
      <div class="col-md-{{ ownerFormArray.length > 1 ? 6 : 12 }}">
        <ng-container>
          @if (ownerFormArray?.length > 1) {
            <div ngClass="{{ index == 0 ? 'tap-main' : 'tap-spouse' }}">
              <span class="tap-text">
                {{ owner?.get('userFirstName')?.value }}
                {{ owner?.get('userLastName')?.value }}
              </span>
            </div>
          }
          <ng-container
            [ngTemplateOutlet]="optionTemplateRef"
            [ngTemplateOutletContext]="{ $implicit: owner, index: index }"
          >
          </ng-container>
        </ng-container>
      </div>
    }
    @if (!owner) {
      <div>
        <p>Error: Owner object is not defined.</p>
      </div>
    }
  }
</div>
